<template>
  <el-dialog
    v-el-drag-dialog
    append-to-body
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    title="新建"
    width="1000px"
    @close="$reset('form')"
  >
    <!-- Begin -->
    <el-form ref="form" :model="model" :rules="ruleValidate" class="form" label-width="90px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="物料名称" prop="materialName">
            <el-input v-model="model.materialName" placeholder="请选择物料" readonly>
              <el-button slot="append" @click="$refs.inventorySelect.open()" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="批次号" prop="batchNo">
            <el-input v-model="model.batchNo" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="库存数量" prop="stockQuantity">
            <el-input v-model="model.stockQuantity" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调拨数量" prop="quantity">
            <el-input v-model="model.quantity" placeholder="请输入调拨数量"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="serialList.length">
          <el-form-item label="序列号" prop="serialNo">
            <el-select v-model="model.serialNo" multiple collapse-tags placeholder="请选择序列号">
              <el-option v-for="item in serialList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调出仓库" prop="outWarehouseName">
            <el-input v-model="model.outWarehouseName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调出仓位" prop="outLocationName">
            <el-input v-model="model.outLocationName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调入仓库" prop="inWarehouseName">
            <el-input v-model="model.inWarehouseName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="调入仓位" prop="inLocationName">
            <el-input v-model="model.inLocationName" placeholder="请选择调入仓位" readonly>
              <el-button slot="append" @click="$refs.locationSelect.open(model.inWarehouseNo)" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- End -->
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleOk">确定</el-button>
    </span>
    <InventorySelect ref="inventorySelect" @select="inventorySelect"></InventorySelect>
    <LocationSelect ref="locationSelect" @select="locationSelect"></LocationSelect>
  </el-dialog>
</template>

<script>
import InventorySelect from "@/views/StoreManagement/Inventory/InventorySelect.vue";
import LocationSelect from "@/views/StoreManagement/StorageOrder/LocationSelect.vue";

export default {
  props: {
    inWarehouseName: {
      type: String,
      default: "",
    },
    inWarehouseNo: {
      type: String,
      default: "",
    },
  },

  components: {
    InventorySelect,
    LocationSelect,
  },

  data() {
    return {
      dialogVisible: false,
      model: {
        materialId: "",
        materialNo: "",
        materialName: "",
        quantity: "",
        batchNo: "",
        serialNo: "",
        outWarehouseNo: "",
        outWarehouseName: "",
        outLocationNo: "",
        outLocationName: "",
        inWarehouseNo: "",
        inWarehouseName: "",
        inLocationNo: "",
        inLocationName: "",
        stockQuantity: "",
      },
      serialList: [], // 序列号列表
      ruleValidate: {
        materialName: { required: true, message: "请选择物料", trigger: "change" },
        quantity: [{ required: true, message: "请输入调拨数量", trigger: "blur" }],
        inLocationName: { required: true, message: "请选择调入仓位", trigger: "change" },
        serialNo: { required: true, message: "请选择序列号", trigger: "blur" },
      },
    };
  },

  methods: {
    open(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.model.inWarehouseNo = this.inWarehouseNo;
        this.model.inWarehouseName = this.inWarehouseName;
        if (row) {
          this.model = Object.assign(this.model, row);
          if (row.stockId) {
            this.getSerialNos(row.stockId);
            this.model.serialNo = row.serialNo.split(",");
          }
        }
      });
    },

    // 选择物料(库存明细)
    inventorySelect(row) {
      this.model.materialId = row.materialId;
      this.model.stockQuantity = row.baseQuantity;
      this.model.materialNo = row.materialNo;
      this.model.materialName = row.materialName;
      this.model.outWarehouseNo = row.warehouseNo;
      this.model.outWarehouseName = row.warehouseName;
      this.model.outLocationNo = row.locationNo;
      this.model.outLocationName = row.locationName;
      this.model.batchNo = row.lot;
      this.model.quantity = "";
      this.model.serialNo = "";
      this.model.unitId = row.unitId;
      this.model.unit = row.unitName;
      this.model.stockId = row.id;
      this.getSerialNos(row.id);
    },

    // 根据物料查询序列号列表
    getSerialNos(id) {
      this.$http.get("basic", "stockDetails/kingdee/serial", { stockId: id }).then((res) => {
        if (res.success) {
          this.serialList = res.data;
        }
      });
    },

    // 选择调入仓位
    locationSelect(row) {
      this.model.inLocationNo = row.locationNo;
      this.model.inLocationName = row.locationName;
    },

    handleOk() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.model.quantity > this.model.stockQuantity) {
            this.$confirm("调拨数量不能超出库存数量", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          if (this.model.serialNo) {
            this.model.serialNo = this.model.serialNo.join();
          }
          this.$emit("save-success", JSON.stringify(this.model));
          this.dialogVisible = false;
        }
      });
    },
  },
};
</script>
